import type { SVGProps } from 'react';
const SvgAddPhotoAlternate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#add_photo_alternate_svg__a)">
      <path
        fill="currentColor"
        d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3Zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3ZM5 19l3-4 2 3 3-4 4 5H5Z"
      />
    </g>
    <defs>
      <clipPath id="add_photo_alternate_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAddPhotoAlternate;
